<template>
  <v-card>
    <v-card-title>        
          <v-col sm="2" xs="12" md="1">
            <v-icon large right>fas fa-users</v-icon>
          </v-col>
          <v-col  sm="4" xs="12" md="2">
            <v-toolbar-title class="pl-3">Users</v-toolbar-title>
          </v-col>
          <v-col  sm="6" xs="12" md="2">
            <v-btn  color="blue darken-3"  outlined @click="dialog = true">New user
              <v-icon right dark>person_add</v-icon>
            </v-btn>
          </v-col>
          <v-col  sm="6" xs="12" md="6">
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-col>
    </v-card-title>
      <nuevoUsuario @usuarioAgregado="traerUsuarios" :titulo="titulo"  :email="email" :dialog="dialog" @cancelar="cancelar" /> 
      <cambiarClave :id="id" :dialogClave="dialogClave" @cancelClave="cancelClave" @claveActualizada="claveActualizada" />
    <v-data-table
      v-on:inseteCliente="traerUsuarios()"
      :headers="headers"
      :items="desserts"
      :search="search">
      <template v-slot:item.actions="{ item }">
          <v-tooltip bottom color="blue darken-2">
            <template v-slot:activator="{ on }">
                <v-btn  @click="editUser(item)" x-small icon color="black" v-on="on">
                    <v-icon >fas fa-user-edit</v-icon>
                </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom color="blue darken-3">
              <template v-slot:activator="{ on }">
                  <v-btn @click="cambiarContraseña(item)" x-small icon color="orange" v-on="on">
                      <v-icon >fas fa-key</v-icon>
                  </v-btn>
              </template>
              <span>Change Password</span>
          </v-tooltip>
          <v-tooltip bottom color="blue darken-3">
              <template v-slot:activator="{ on }">
                  <v-btn @click="configureUser(item)" x-small icon color="blue darken-3" v-on="on">
                      <v-icon >fas fa-user-cog</v-icon>
                  </v-btn>
              </template>
              <span>User configuration</span>
          </v-tooltip>
          <v-tooltip bottom color="blue darken-2">
            <template v-slot:activator="{ on }">
                <v-btn  @click="deleteUser(item)" x-small icon color="black" v-on="on">
                    <v-icon >fas fa-trash-alt</v-icon>
                </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your serach "{{ search }}" not have result.
        </v-alert>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogConfigUser" persistent max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Configuration User</span>
        </v-card-title>
        <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-col cols="12" sm="6" md="6">
            <v-radio-group v-model="rol" column @change="disableSave=false">
              <v-radio
                label="Administrator"
                color="#6A1B9A"
                value="e1bbad92-d631-4780-a097-9acb889154ab"
              ></v-radio>
              <v-radio
                label="Worker"
                color="#F3E5F5"
                value="e1bbad92-d631-4780-a097-9acb889154ci"
              ></v-radio>
            </v-radio-group>
          </v-col>
              </v-layout>
            </v-container>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error"  @click="dialogConfigUser = false" outlined>Cancel
              <v-icon right dark>cancel</v-icon>
          </v-btn>
          <v-btn color="#008ACD" v-on:click="updateUser()" outlined :disabled ="disableSave">Save
              <v-icon right dark>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <updateUser :user="userModel" @usuarioAgregado="traerUsuarios"  :email="email" :dialog="dialogUpdate" @cancelarUser="cancelarUpdate" /> 
  </v-card>
</template>

<script>
import HTTP from '../../services/index.ts';
import nuevoUsuario from './NewUser.vue';
import updateUser from './updateUser.vue';
import cambiarClave from './changePassword.vue'
import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
import Swal from 'sweetalert2'
export default {

    data () {
      return {
        id:'',
        search: '',
        desserts:[],
        text:'hello',
        dialog:false,
        dialogUpdate:false,
        dialogClave:false,
        email:'',
        dialogConfigUser:false,
        rol:'',
        disableSave:true,
        userModel:{},
        titulo:'',
        headers: [
          { text: 'User Name', align: 'left', value: 'name'},
          { text: 'Email', align: 'left', value: 'nombre'},
          { text: 'Alias', align: 'left', value: 'alias'},
          { text: 'State', align: 'left',  value: 'confirmado' },
          {text: 'Phone Number', align:'left', value: 'phoneNumber'},
          { text: 'Actions', value: 'actions',align: 'center', sortable: false }
        ],
        //para dialog de configuracion de usuario
        dialogConfigureUser:false,
        userName:'',
        dessertsUserRoles:[],
        userId:'',
        //modulos
        dessertsUserModulos:[],
        dessertsUserAcciones:[]
      }
    },
   
    created () {
        this.traerUsuarios();
    },
    components: {
      'cambiarClave':cambiarClave,
      'nuevoUsuario':nuevoUsuario,
      'updateUser':updateUser
    }, 


    methods: {
      cancelarUpdate(){
        this.dialogUpdate=false
      },
      editUser(item){
        console.log('user => ', item)
        this.userModel = item
        this.dialogUpdate=true
      },
      async deleteUser(item){
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
                buttonsStyling: true
            })

            swalWithBootstrapButtons.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true
                }).then(async(result) => {
                if (result.isConfirmed) {
                    var data = new FormData();
                    data.append('user',item.id);
                    const response = await HTTP.post('/usuarios/inactive', data)
                    if(response){
                        this.traerUsuarios()
                        swalWithBootstrapButtons.fire('Deleted!','User deleted successfully','success')
                    }else{
                        showMessageError('An error ocurred')
                    }
                }
            })
      },
      updateUser (){
        var data = {idUser: this.userId, idRol:this.rol}
          HTTP.post('/usuarios/asignateRole', data)
          .then(response => {
              this.dialogConfigUser=false
              showMessageSuccess('Role assigned correctly')
          }).catch(error => {
              showMessageError('An error was ocurrd, try again')
          });
      },
      claveActualizada(){
        this.dialogClave=false;
      },
      cancelClave(){
        this.dialogClave=false;
      },
      cancelar(){
      this.dialog=false;
    },
    cambiarContraseña(user){
      this.id=user.id;
      this.dialogClave=true;
    },

    cargarTablaUsuarios(usuario){
        this.desserts=[]
        Object.keys(usuario).forEach((element,key,_array)=>{
            var state=''
            if(usuario[element].emailConfirmed === true) {
              state ='Active' }
              else {state ='Inactive'}
            this.desserts.push({
                id:usuario[element].id,
                alias:usuario[element].alias,
                nombre:usuario[element].userName,
                name:usuario[element].name,
                confirmado: state ,
                phoneNumber: usuario[element].phoneNumber
            });
        });
    },

    traerUsuarios(){
        let _this = this;
        this.dialog = false
        this.dialogUpdate=false
        HTTP.get('/usuarios/readUsers')
        .then(response => {
            this.cargarTablaUsuarios(response.data)
        }).catch(eror => {
            //console.log('se produjo un error al leer los usuaris');
        });
    },

    //para la configuracion de usuario
    
    cerrar(){
      this.dialogConfigureUser=false;
    },

     configureUser(item){
      this.userId = item.id
      this.userName= item.nombre       
       this.getUserRol(item.id)
      this.dialogConfigUser=true 
      this.disableSave=true
    },  

     getUserRol(userId){
      HTTP.get('/usuarios/'+userId)
      .then(response => {
        this.rol = response.data.roleId
      }).catch(eror => {
        //console.log('error in function get user rol')
      });
    }

  }
}
</script>